import Avatar, { type AvatarProps } from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import { getProfilePicUrl } from '@/api/urls';
import { getUserLabels, type ProfilePictureUser, styles } from './utils';

export interface ProfilePictureProps extends AvatarProps {
  user: ProfilePictureUser;
  size?: number;
  className?: string;
  isLoading?: boolean;
}

export default function ProfilePicture({
  user,
  size = 40,
  className,
  isLoading,
  children,
  ...props
}: ProfilePictureProps) {
  if (!user) return null;
  const labels = getUserLabels(user);
  const sx = styles.shared(size);
  const sharedProps = {
    sx,
    alt: labels.name,
    className,
    ...props,
  };
  if (isLoading) {
    return (
      <CircularProgress
        sx={styles.circularProgress}
        thickness={2}
        size={size}
      />
    );
  }
  if (user && user.userPreferences?.profilePicSource) {
    return (
      <Avatar
        src={getProfilePicUrl(user.userPreferences.profilePicSource.value)}
        {...sharedProps}
      />
    );
  }
  const avatarProps = {
    ...sharedProps,
    sx: { ...sx, ...styles.avatar },
  };
  return <Avatar {...avatarProps}>{labels.initials}</Avatar>;
}
